import { Box, Chip, Fade, Typography } from "@mui/material";
import api from "../../Services/Api";
import React, { useEffect, useState } from "react";
import * as Sentry from "@sentry/browser";
import { useTranslation } from 'react-i18next';

const Pipeline = ({dealPipeline, selectPipeline, loaded, setNextDisabled}) => {
    const { t } = useTranslation();
    const [pipeline, setPipeline] = useState({id: "", label: ""});
    const [options, setOptions] = useState([]);
    useEffect(() => {
        api.fetchPipelines().then((result) => {
            if(result.length == 1) {
                let pipelineToSelect = result[0]
                setNextDisabled(false)
                setPipeline(pipelineToSelect)
                setOptions(result)
                selectPipeline({
                    id: pipelineToSelect.id,
                    name: pipelineToSelect.label,
                    stages: pipelineToSelect.stages
                }, true)
            } else {
                if(dealPipeline != undefined) {
                    setNextDisabled(false)
                    var pipelineToSelect = result.filter((pipeline) => pipeline.id == dealPipeline.id)
                    if(pipelineToSelect.length > 0) {
                        pipelineToSelect = pipelineToSelect[0]
                        setPipeline(pipelineToSelect)
                        selectPipeline({
                            id: pipelineToSelect.id,
                            name: pipelineToSelect.label,
                            stages: pipelineToSelect.stages
                        }, false);
                    }
                }
                setOptions(result);
                loaded();
            }
        }).catch((error) => {
            Sentry.captureException(error);
            console.log(error)
        })
    }, []);

    const handleSelect = (p) => {
        setNextDisabled(false);
        setPipeline(p);
        selectPipeline({
            id: p.id,
            name: p.label,
            stages: p.stages
        }, false);
    };

    if (options.length === 0) return null;

    const isSingle = options.length === 1;

    return (
        <Fade in timeout={300}>
            <Box sx={{ width: '100%' }}>
                <Typography variant="subtitle2" sx={{ color: 'rgba(255,255,255,0.7)', mb: 1, fontWeight: 600 }}>
                    {t('pipeline')} *
                </Typography>
                <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }} data-testid="pipeline-radio-group">
                    {options.map((p) => (
                        <Chip key={p.id} label={p.label}
                            data-testid={`pipeline-option-${p.id}`}
                            onClick={isSingle ? undefined : () => handleSelect(p)}
                            sx={{
                                height: 44, borderRadius: '22px', minWidth: 80,
                                fontWeight: pipeline.id === p.id ? 700 : 500,
                                backgroundColor: pipeline.id === p.id ? '#1f7a7a' : 'rgba(255,255,255,0.08)',
                                color: pipeline.id === p.id ? '#fff' : 'rgba(255,255,255,0.9)',
                                border: pipeline.id === p.id ? '2px solid #1f7a7a' : '1px solid rgba(255,255,255,0.3)',
                                cursor: isSingle ? 'default' : 'pointer',
                                transition: 'all 0.2s ease',
                                '&:hover': {
                                    backgroundColor: pipeline.id === p.id ? (isSingle ? '#1f7a7a' : '#176b6b') : 'rgba(255,255,255,0.14)',
                                },
                            }}
                        />
                    ))}
                </Box>
            </Box>
        </Fade>
    );
}

export default Pipeline;
